/**
 * Suddivide il testo importato utilizzando il separatore più ricorrente tra
 * virgole e punti e virgola, considerando anche i ritorni a capo come
 * separatori. Eventuali liste puntate o numerate vengono normalizzate
 * rimuovendo il prefisso prima dell'aggiunta.
 *
 * @param text Testo incollato dall'utente
 * @returns Lista di elementi normalizzati
 */
export const parseImportText = (text: string): string[] => {
  const comma = (text.match(/,/g) || []).length;
  const semi = (text.match(/;/g) || []).length;
  const sep = semi > comma ? ';' : ',';
  return text
    .replace(/\r/g, '')
    .split(new RegExp(`[\n${sep}]`))
    .map(p =>
      p
        .replace(/^\s*(?:[-*•]\s*|\d+\s*[.).-]\s*)/, '')
        .trim()
    )
    .filter(Boolean);
};

